import React, { ReactNode } from "react";
import Tag from "../../../../../generic/tag";
import OverflowButton from "../../../../../generic/overflowButton";
import { IIpo } from "../../../../../types/components/orderBook/obTypes";
import {
  ChipColorKeyComb,
  ovrOptions,
  scrlStCls,
  ObScrollStyle,
} from "../../../obConstants";
import { toINR } from "../../../../../service/numberFormat";
import { HObGroupBy } from "../../../../../service/orderBook/obGrpByHelper";
import indexer, { IListObj } from "../../../../../types/genericTypes";
import ObAssetDetailPopup from "../../../generic/obAssetDetailPopup";
import ObIpoDtlsDsk from "../../../obDetails/dsk/obIpoDtlsDsk";
import Sort, { eSortState, sort } from "../../../../../generic/sort";
import { ChipStatusComb } from "./../../../obConstants";
import bStrg from "../../../../../service/storageHelper";
import { dateTimeFormat } from "../../../../../service/dateTimeService";
import ObUtilHeader from "../../../obContainer/obUtilHeader";
import { SearchHighLight } from "../../../../../service/generic/searchHighlight";
import TocNoData from "../../../../generic/tocNoData/tocNoData";
import ee from "../../../../../utils/eventEmitter";
import { AIpoCancelTrd } from "../../../../../service/orderBook/obApiService";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";

export interface ObIpoProps {
  data: Array<any>;
  isHistory: boolean;
  noDataNode: ReactNode;
  reRenderCall?: (value: string) => void;
  hidePageNav?: (hide: boolean) => void;
}

// heading for IPO Asset table
const heading: indexer = {
  company: "Company Name",
  qty: "Qty.",
  price: "Price",
  amount: "Total  Blocked Amt.",
};

const sortColumn: indexer = {
  company: "ipoNm",
};

const ObIpo: React.FC<ObIpoProps> = (props) => {
  const ovrOpts: Array<IListObj> = ovrOptions;

  for (let i = 0; i < props.data.length; i++) {
    let element: IIpo = props.data[i];
    var temp: Array<IListObj> = [];
    element["sts"] =
      element.mwStatus.split("-").length !== 1
        ? element.mwStatus.split("-")[1].trim()
        : element.mwStatus.split(" ")[1].trim();
    element["sts"] = element["sts"].toLowerCase();
    if (element.isModify) {
      temp.push(ovrOpts[0]);
    }
    if (element.isCancel) {
      temp.push(ovrOpts[1]);
    }
    temp.push(ovrOpts[4]); //details

    element.ovrOpts = temp;
  }
  // wherever initial data needs to be sent, send initialData
  // initial data is array of array for supporting grouping
  const initialData = [JSON.parse(JSON.stringify(props.data))],
    todayDate = bStrg("todayDate") || new Date();
  let [tableData, setTableData] = React.useState(initialData);

  let ipoData: Array<{ [x: string]: Array<IIpo> }> | null = null;

  React.useEffect(() => {
    setTableData([props.data]);
  }, [props.data, props.isHistory]);

  if (props.data) {
    //group data based on biddingEndDate
    let results = tableData.map((group) =>
      group.reduce(
        (arr: any, d: IIpo) => {
          if (
            dateTimeFormat(d.biddingEndDate, "-").setHours(0, 0, 0) >=
              new Date(todayDate).setHours(0, 0, 0) &&
            d.biddingEndDate
          ) {
            arr[0] = [...arr[0], d];
          } else {
            arr[1] = [...arr[1], d];
          }
          return arr;
        },
        [[], []]
      )
    );

    ipoData =
      tableData.length > 0 && results[0][!props.isHistory ? 0 : 1].length > 0
        ? [HObGroupBy(results[0][!props.isHistory ? 0 : 1], "submitDt", ",")]
        : null;
  }

  // filteredData contains filtered, searched data
  const [filteredData, setFilteredData] =
    React.useState<Array<Array<{}>>>(initialData);
  //is popup data
  const [popupDataIndex, setPopupDataIndex] =
    React.useState<[string, number]>();

  const [sortedColumnState, setSortedColumnState] = React.useState({
    colName: null as string | null,
    sortState: eSortState.ASC,
  });

  function onSort(data: Array<Array<any>>, sortState: eSortState) {
    setSortedColumnState({ colName: heading.symbol, sortState: sortState });
    setTableData(data);
  }

  //after applying filters following method will invoked to show the updated results
  function onDataFilter(data: Array<any>, sText: string = "", type?: string) {
    setFilteredData(data);

    // sort only if colName is present, otherwise there is no need to sort
    if (sortedColumnState.colName) {
      const colNameKey = Object.keys(heading).find(
        (key) => heading[key] === sortedColumnState.colName
      )!;
      sort(data, sortedColumnState.sortState, sortColumn[colNameKey], onSort);
    }
    //highlightes the search text
    if (sText) {
      const SearchText: string = sText.toLowerCase();
      data[0].forEach((ord: IIpo) => {
        ord.ipoNm = SearchHighLight(ord.ipoNm, SearchText);
      });
    }
    setTableData(data);
  }

  // this function excute on clicking any row
  function onRowClick(data: any, groupIndex: string, index: number, e?: any) {
    if (
      e &&
      !e.nativeEvent.path.find(
        (m: HTMLElement) =>
          m.className &&
          (m.className.indexOf("check") >= 0 ||
            m.className.indexOf("menu") >= 0)
      )
    ) {
      setPopupDataIndex([groupIndex, index]);
    }
  }
  function optSelection(
    id: string | number,
    data: {
      gI: string;
      ind: number;
      ordData: indexer;
    }
  ) {
    switch (id) {
      case "details":
        setPopupDataIndex([data.gI, data.ind]);
        break;
      case "cancel":
        cancelOrder(data.ordData);
        break;
      default:
        //console.log("404");
        break;
    }
  }
  let ordCancelledSuccList: Array<string> = [],
    ordCancelledFailList: Array<string> = [],
    ordsListToCancel: Array<string> = [];

  // runs after all cancel api response
  function cancelCallback(res: any) {
    if (res.data) {
      // if success
      ordCancelledSuccList.push(res.data);
    } else {
      // if error
      ordCancelledFailList.push(res.error);
    }

    // when we get all the responses
    if (
      ordCancelledSuccList.length + ordCancelledFailList.length ===
      ordsListToCancel.length
    ) {
      ee.emit("showToast", {
        message: `Cancelled ${ordsListToCancel.length} Orders`,
        color: "cancell",
      });

      props.reRenderCall && props.reRenderCall("today");
    }
  }

  // TO DISCUSS: Whick paramenters to send in the body of AIpoCancelTrd
  function cancelOrder(data: any) {
    ordsListToCancel.push(data.ordID);
    AIpoCancelTrd(cancelCallback, data.ordID);
  }

  function ipoRw(data: IIpo, groupIndex: string, index: number) {
    return (
      <li
        className="ipo_data ins_data"
        key={index}
        onClick={(e) => onRowClick(data, groupIndex, index, e)}
      >
        <div className="col time">
          <span>
            {data.submitDt
              .split(",")[1]
              .replace(/am|pm/gi, ":00")
              .replace(/\s/gi, "")}
          </span>
        </div>
        <div className="col txn_typ">
          <span>
            <Tag
              value="B"
              shape="mini_circle"
              color="green"
              height="22px"
              width="22px"
            />
          </span>
        </div>
        <div className="col comp">
          <span dangerouslySetInnerHTML={{ __html: data.ipoNm }}></span>
        </div>
        <div className="col qty taRight">
          <span>
            {data.bids.length} (
            {data.bids.length !== 0 &&
              data.bids
                .map((el) => el.quantity)
                .reduce((accumulator, currentValue) => {
                  return accumulator + currentValue;
                })}
            {data.bids.length === 0 && data.bids.length} Qty)
          </span>
        </div>
        <div className="col price taRight">
          <span>
            {data.bids.length !== 0 && "₹"}
            {data.bids.length !== 0 &&
              toINR(
                data.bids
                  .map((el) => el.amount)
                  .reduce((accumulator, currentValue) => {
                    return accumulator + currentValue;
                  }),
                0
              )}
            {data.bids.length === 0 && "--"}
          </span>
        </div>
        <div className="col amt taRight">
          <span>₹{toINR(data.upiAmtBlocked, 2)}</span>
        </div>
        <div className="col sts">
          <span>
            <Tag
              value={ChipStatusComb[data.sts.toLowerCase()]}
              shape="chip"
              color={ChipColorKeyComb[data.sts]}
            />
          </span>
        </div>
        <div className="col menu">
          {data.ovrOpts && (
            <OverflowButton
              defaultValue={"modify"}
              dropdownOptions={data.ovrOpts}
              onSelect={optSelection}
              onHover={true}
              data={{
                ordData: data,
                gI: groupIndex,
                ind: index,
              }}
            />
          )}
        </div>
      </li>
    );
  }
  return (
    <>
      <ObUtilHeader
        leftSideText={
          ipoData ? (
            <div className="executed">
              <span className="text">Executed Orders: </span>
              <span className="value">
                {ipoData.map((g) =>
                  Object.keys(g)
                    .map(
                      (date) =>
                        g[date].filter(
                          (rw: IIpo) =>
                            rw.applicationNumber || rw.referenceNumber
                        ).length
                    )
                    .reduce((acc, cv) => {
                      return acc + cv;
                    })
                )}
                /
                {ipoData &&
                  Object.keys(ipoData[0])
                    .map((key: string) =>
                      ipoData ? ipoData[0][key].length : 0
                    )
                    .reduce((acc, cv) => {
                      return acc + cv;
                    })}
              </span>
            </div>
          ) : (
            <></>
          )
        }
        data={
          (ipoData && Object.keys(ipoData).length) || !tableData[0]
            ? initialData
            : [[]]
        }
        searchKey="ipoNm"
        onDataFilter={onDataFilter}
        onSelectClick={undefined}
        onFilterClick={() => {}}
        filterReqData={{
          status: "sts",
          aType: "pm",
          showOpenOrderOnTop: false,
          showOpenOrderTgl: false,
          isHistory: props.isHistory ? true : false,
        }}
        onSearchClick={(e) => {
          // if exists, then call it
          // props.hidePageNav && props.hidePageNav(e);
        }}
      />

      <div className="ipo_table ins_tabl">
        {/* ob IPO Header Row */}
        {(ipoData !== null || !tableData[0]) && (
          <ul className={scrlStCls.pOffset + " hdr_row"}>
            <li>
              <div className="col time"> </div>
              <div className="col txn_typ"> </div>
              <div className="col comp ">
                {!props.isHistory && (
                  <Sort
                    sortList={filteredData}
                    sortedColName={sortedColumnState.colName}
                    sortKey={sortColumn.symbol}
                    onSort={onSort}
                    colName={heading.company}
                  />
                )}
                {props.isHistory && heading.company}
              </div>
              <div className="col qty taRight">{heading.qty}</div>
              <div className="col price taRight">{heading.price}</div>
              <div className="col amt taRight">{heading.amount}</div>
              <div className="col sts"></div>
              <div className="col menu"></div>
            </li>
          </ul>
        )}
        <div
          className={props.data.length > 0 ? "ObScrollCont" : ""}
          style={ObScrollStyle(props.data.length > 0 ? true : false)}
        >
          {/* ob IPO offer content Row */}
          {ipoData !== null &&
            ipoData.map((group, groupIndex) =>
              Object.keys(group).map((date, Gindex) => {
                return (
                  <React.Fragment key={Gindex}>
                    {/* if history componenet need to show*/}

                    <ul
                      className={scrlStCls.freeze + " eq_hist_date hist_date"}
                      key={"dtGp" + Gindex}
                    >
                      <li>{date.split(",")[0]}</li>
                    </ul>
                    <ul
                      className={scrlStCls.toContext}
                      key={"dtUlDet" + Gindex}
                    >
                      {group[date].map((row: any, index: number) =>
                        ipoRw(row, date, index)
                      )}
                    </ul>
                  </React.Fragment>
                );
              })
            )}
        </div>
      </div>

      {tableData[0] &&
        ipoData === null &&
        props.data.length === tableData[0].length &&
        props.noDataNode}
      {!tableData[0] && (
        <TocNoData data={initialData} callBackMeth={onDataFilter} />
      )}

      {popupDataIndex && ipoData && (
        <ObAssetDetailPopup>
          <ObIpoDtlsDsk
            data={
              ipoData !== null &&
              ipoData[0][popupDataIndex[0]][popupDataIndex[1]]
            }
            onBackClick={() => setPopupDataIndex(undefined)}
            onCancelClick={() =>
              cancelOrder(
                ipoData !== null &&
                  ipoData[0][popupDataIndex[0]][popupDataIndex[1]]
              )
            }
          />
        </ObAssetDetailPopup>
      )}
    </>
  );
};

export default ObIpo;
